import utils from 'utils';
import {useEffect, useState} from 'react';

import {UiButton, UiMonthPicker} from '@components/export';
import {useLabel} from '@/hooks/export';

import moment, {Moment} from 'moment';

export const ReportSidePanel = (props: {
    onProductSelect: (name: string) => void,
    onSearch: (date: Moment) => void,
    reportData: apiReportData,
}) => {
    const label = useLabel();

    const [selectedProductName, setSelectedProductName] = useState('');
    const [selectedDate, setSelectedDate] = useState(moment());
    const [qtyDone, setQtyDone] = useState(0);

    useEffect(() => {
        setQtyDone(countAllDoneProducts(props.reportData));
    }, [props.reportData]);

    return <div className={cmpClass}>
        <div className={classMap.controls}>
            <span className={classMap.controlsTitle}>Report za obdobi</span>
            <div className={classMap.controlsBox}>
                <div className={classMap.dateSelector}>
                    <UiMonthPicker
                        value={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        label={label.monthAndYear}
                    />
                </div>
                <div className={classMap.action}>
                    <UiButton
                        style={2}
                        text={label.show}
                        icon={'iconfa-search'}
                        onClick={() => props.onSearch(selectedDate)}
                    />
                </div>
            </div>
        </div>
        <div className={classMap.resultsWrapper}>
            {
                props.reportData ?
                    <>
                        <div className={classMap.listTitle}>
                            <h3>{label.totalDone}{':'}</h3>
                            <div className={classMap.listTitleLine}>
                                <span className={'with-color'}>{qtyDone}&nbsp;</span>
                                <span>{label.qty}&nbsp;</span>
                                <span>{'/'}&nbsp;</span>
                                <span className={'with-color'}>{props.reportData.totalPriceNoVAT}&nbsp;</span>
                                <span>{label.currency + ' ' + label.noVat}</span>
                            </div>
                        </div>
                        <div className={classMap.listWrapper}>
                            <div className={classMap.list}>
                                {
                                    getProductList(props.reportData).map((item, i) => {
                                        return <div
                                            className={classMap.listItem + (item.name === selectedProductName ? ' ' + classMap.listItemActive : '')}
                                            key={i}
                                            onClick={() => {
                                                const productName = item.name === selectedProductName ? '' : item.name;

                                                setSelectedProductName(productName);
                                                props.onProductSelect(productName);
                                            }}
                                        >
                                            <span>{item.name}</span>
                                            <span>{item.qty} {label.qty}</span>
                                        </div>;
                                    })
                                }
                            </div>
                        </div>
                    </> : <></>
            }
        </div>
    </div>;
};

const cmpClass = 'report-side-panel';
const classMap = utils.generateClassMap(cmpClass, {
    controls: 'controls',
    controlsTitle: 'controls-title',
    controlsBox: 'controls-box',
    dateSelector: 'date-selector',
    action: 'action',
    listWrapper: 'list-wrapper',
    listTitle: 'list-title',
    listTitleLine: 'list-title-line',
    list: 'list',
    listItem: 'list-item',
    listItemActive: 'list-item--active',
    resultsWrapper: 'results-wrapper',
});

const getProductList = (data) => {
    const productList = [];

    Object.entries(data.products).map((entry) => {
        const [label, stats] = entry;

        let qtyAcc = 0;

        Object.entries(stats).map((statsEntry) => {
            qtyAcc += statsEntry[1].qty;
        });

        if (qtyAcc) {
            productList.push({
                name: label,
                qty: qtyAcc,
            });
        }
    });

    return productList.sort((a, b) => a.qty < b.qty ? 1 : -1);
};

const countAllDoneProducts = (data) => {
    let qtyAcc = 0;

    if (data && data.products) {
        Object.entries(data.products).map((entry) => {
            Object.entries(entry[1]).map((statsEntry) => {
                qtyAcc += statsEntry[1].qty || 0;
            });
        });
    }

    return qtyAcc;
};
